"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../styles/styles"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const changepasswordFormComponent_1 = __importDefault(require("./changepasswordFormComponent"));
const ChangePassword = () => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles, styles_1.default.minHeight] },
    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginLeftTwenty, styles_1.default.alignCenterCenter] },
        react_1.default.createElement(boxTitle_1.default, { title: "Change Password" })),
    react_1.default.createElement(changepasswordFormComponent_1.default, null)));
exports.default = ChangePassword;
